module.exports = __webpack_public_path__ + "img/earncoins_icon.2437328e.png";